var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.data.ledgersItemWise,
      "row-key": "id",
      border: "",
      "default-expand-all": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      width: "40"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "product.name",
      label: "Name",
      width: "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.product.name) + " "), _c("br"), scope.row.productsVariation ? _c("small", [_vm._v("(" + _vm._s(scope.row.productsVariation.name) + ")")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mrp",
      label: "MRP",
      width: "70",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.mrp ? [_c("inr", {
          attrs: {
            number: scope.row.mrp
          }
        })] : [_vm._v(" - ")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "quantity",
      label: "Quantity(PCS)",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.quantity) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "moqDiscount",
      label: "MOQ",
      width: "120",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.moqDiscount ? [_vm._v(" " + _vm._s(scope.row.moqDiscount) + "% ")] : [_vm._v(" " + _vm._s(0) + " ")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "policiesDiscount",
      label: "Policy",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.policiesDiscount && scope.row.policiesDiscountType ? [_vm._v(" " + _vm._s(scope.row.policiesDiscount) + _vm._s(scope.row.policiesDiscountType === "percent" ? "%" : "/-") + " ")] : [_vm._v(" " + _vm._s(0) + " ")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "schemesDiscount",
      label: "Scheme",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.schemesDiscount ? [_vm._v(" " + _vm._s(scope.row.schemesDiscount) + "% ")] : [_vm._v(" " + _vm._s(0) + " ")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "discountAmount",
      label: "Discount",
      width: "120",
      align: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.discountAmount
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "nettRate",
      label: "Nett Rate",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.nettRate
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Total",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.nettRate * scope.row.quantity
          }
        })];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };